export const PROJECT_LIST_NAMES_SUCCESS = "PROJECT_LIST_NAMES_SUCCESS"
export const PROJECT_LIST_NAMES_FAILURE = "PROJECT_LIST_NAMES_FAILURE"
export const PROJECT_LIST_NAMES_REQUEST = "PROJECT_LIST_NAMES_REQUEST"
export const RESET_PROJECTS_STORE_REQUEST = "RESET_PROJECTS_STORE_REQUEST"
export const RESET_PROJECTS_STORE_SUCCESS = "RESET_PROJECTS_STORE_SUCCESS";